import $ from 'jquery';

/**
 * barba
 */

import BjzmBarbaScripts from './custom/bjzm-barba/bjzm-barba.js';

import ParallaxHero from './custom/parallax-hero';

import * as Cookies from "cookies-js";

jQuery(document).ready(function($) {

	var BjzmBarba = new BjzmBarbaScripts();

	var waitTime = 0;
	if( $(".loading-screen-bg").length > 0 ) {
		waitTime = 5000;
		setTimeout(function(){
			$(".loading-screen-bg").fadeOut();
			$('body').removeClass('bjzm-transition-in');
		}, 4000);
	}

	if( BJZM_DATA.is_property_page ) {

		// var PropertyHero = new ParallaxHero();

	}

	// market filter toggle open/close
	$('.market-filter__current').on('click',function(){
		const filter = $(this).closest('.market-filter');
		$(this).toggleClass('mf-active');
		filter.find('.market-filter__list').slideToggle();
	});
	// market filter toggle filter properties
	$('.market-filter__list span').on('click',function(){		
		const filter = $(this).closest('.market-filter');
		const properties = $('.home-gallery__property');
		$(this).addClass('mf-active').siblings().removeClass('mf-active');
		if ($(this).text() == "All") {
			filter.find('.market-filter__current').text(filter.data('default')).trigger('click');
			properties.show();
		} else {
			filter.find('.market-filter__current').text($(this).text()).trigger('click');
			properties.each(function(){
				const market = $(this).data('market');
				if (market != '') {
					if (market == $('.market-filter__current').text()) {
						$(this).show();
					} else {
						$(this).hide();
					}
				} else {
					$(this).hide();
				}
			});
		}
		// redo odd/even classes
		$('.home-gallery__property:visible').each(function(index, item){
			$(this).removeClass('home-gallery__property--even home-gallery__property--odd');
			index%2==0 ? $(this).addClass('home-gallery__property--even') : $(this).addClass('home-gallery__property--odd');
		});
	});
});

